// components
import { PopoverPosition } from '@mui/material';
import { ContextMenu } from 'components/mrp/components/ContextMenu';

// types
import {
  ClickData,
  EntityCalendarRightClickHandlerProps
} from './EntityCalendarRightClickHandler.types';

// react/libs
import { useEffect, useState } from 'react';

// styles
import { EntityCalendarRightClickContainer } from './EntityCalendarRightClickHandler.styles';
import {
  getCellDataFromClickEvent,
  useGetEntityRightClickActions
} from './EntityCalendarRightClickHandler.utils';

// stores
import { useCalendarNavigationStore } from '../store/calendarNavigationStore.store';

const EntityCalendarRightClickHandler = ({
  children
}: EntityCalendarRightClickHandlerProps) => {
  const [pos, setPos] = useState<PopoverPosition | undefined>();
  const [forceOpen, setForceOpen] = useState<boolean>(false);

  const [clickData, setClickData] = useState<ClickData>();

  // We need to set the position to the clicked (also right-clicked) cell so that the calendar navigation is updated.
  const setPosition = useCalendarNavigationStore(
    (state) => state.control.setPosition
  );

  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const clickData = getCellDataFromClickEvent(event);
    setClickData(clickData);

    if (!clickData) return;

    if (clickData.calendarId && clickData.date) {
      setPosition({ calendarId: clickData.calendarId, date: clickData.date });
    }

    setPos({ top: event.clientY, left: event.clientX });
    setForceOpen(true);
  };

  useEffect(() => {
    if (!forceOpen) setPos(undefined);
  }, [forceOpen]);

  const actions = useGetEntityRightClickActions(
    () => setForceOpen(false),
    clickData
  );

  return (
    <EntityCalendarRightClickContainer onContextMenu={onClick}>
      {pos && actions.length > 0 && (
        <ContextMenu
          forceOpen={forceOpen}
          onMenuClose={() => setForceOpen(false)}
          actions={actions}
          id="entity-calendar-right-click"
          anchorPosition={pos}
        />
      )}

      {children}
    </EntityCalendarRightClickContainer>
  );
};

export default EntityCalendarRightClickHandler;
